import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient.js'



export default function NameOnUpload({testGroupID, handleNameUpload, onClose}){
    const [selectableStudents, setSelectableStudents] = useState([])
    const [selectedStudent, setSelectedStudent] = useState(null)

    console.log(`test group id er i dette tilfælde ${testGroupID}`)

    async function fetchSelectableStudents(){
        console.log("starting selectable students")
        try{
            const result = await apiClient.get('/api/testgroup/getselectablestudents', {
                params: {testGroupID: testGroupID}
            })
            setSelectableStudents(result.data)
            console.log(result)
            console.log("we found seletable students " + result.rowCount)
        }catch(e){
            console.log( "error in the fetch assignable students")
            console.log(e)
        }

    }

    useEffect(()=>{
        fetchSelectableStudents()
    }, [])

    function handleSubmit(e){
        e.preventDefault()
        console.log(`here is student ${selectedStudent?.fornavne}`)
        handleNameUpload({studentID: selectedStudent.id, testGroupID: testGroupID})
        onClose()
    }



    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Tilføj kursist</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="form-group">
                    <button type="button" onClick={
                        ()=>{
                            handleNameUpload({studentID: null, testGroupID: testGroupID});
                            onClose() 
                        }
                    }>Upload til prøvegruppen</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-form-grid">

                        <div className="form-group">
                            <label>Kursist:</label>
                            <select onChange={(e) => setSelectedStudent(selectableStudents.find(s=> s.id === parseInt(e.target.value)))}>
                                <option key="0" value="0">Ingen valgt</option>
                                {selectableStudents?.length>0 && selectableStudents.map((student) => (
                                    <option key={student.id} value={student.id}>{student.fornavne} {student.efternavn}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="modal-actions"  style={{marginTop: '20px'}}>
                        <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                        <button type="submit" className="btn-save">Tilføj kursist</button>

                    </div>
                </form>
            </div>
        </div>
    )
}
